export default {
  eyebrow: 'Account',
  title: 'Profile',
  description: 'Your account.',
  role: 'Role',
  userId: 'User ID',
  roleAdmin: 'Admin',
  roleSiteManager: 'Site manager',
  languageHint: 'The language CrewPresence is shown in on this browser.',
  profilePicture: 'Profile picture',
  profilePictureHint: 'JPEG, PNG or WebP, cropped to a square.',
  profilePictureUpdated: 'Profile picture updated.',
  profilePictureRemoved: 'Profile picture removed.',
  photo: 'Photo',
  photoHint: 'Employees can also set their own from the app.',
  photoUpdated: 'Photo updated.',
  photoRemoved: 'Photo removed.',
  companyLogo: 'Company logo',
  companyLogoUpdated: 'Company logo updated.',
  companyLogoRemoved: 'Company logo removed.',
  uploading: 'Uploading…',
  change: 'Change',
  upload: 'Upload',
  notAnImage: 'That file could not be read as an image.',
  editProfile: 'Edit profile',
  editProfileHint: 'Shown in place of your email wherever your name appears.',
  displayName: 'Display name',
  notSet: 'Not set',
  profileUpdated: 'Profile updated.',
  changeEmail: 'Change email',
  changeEmailHint: 'This is also the email you sign in with.',
  currentPassword: 'Current password',
  confirmBeforeEmailChange: "Confirm it's you before changing your sign-in email.",
  showPassword: 'Show password',
  hidePassword: 'Hide password',
  emailUpdated: 'Email updated.',
  updating: 'Updating…',
  updateEmail: 'Update email',
  changePassword: 'Change password',
  changePasswordHint: 'Changing your password signs out every other session on your account.',
  newPassword: 'New password',
  newPasswordHint: 'At least 8 characters.',
  confirmNewPassword: 'Confirm new password',
  passwordsDontMatch: "Passwords don't match.",
  passwordUpdated: 'Password updated.',
  updatePassword: 'Update password',
  copied: 'Copied.',
  copyFailed: "Couldn't copy. Select the text and copy it manually.",
  mfaTitle: 'Two-step verification',
  mfaDescription: 'Ask for a 6-digit code from an authenticator app (Microsoft Authenticator, Google Authenticator, 1Password) as well as your password when you sign in.',
  on: 'On',
  off: 'Off',
  mfaTurnedOff: 'Two-step verification turned off.',
  mfaOnSaveCodes: 'Two-step verification is on. Save your recovery codes.',
  recoveryCodesHelp: "If you lose your phone, each of these signs you in once. This is the only time they're shown, so store them somewhere safe, like a password manager.",
  recoveryCodes: 'Recovery codes',
  copyCodes: 'Copy codes',
  savedCodes: "I've saved these",
  setupStep1: '1. Add CrewPresence to your authenticator app',
  setupStep1Help: 'Choose "enter a setup key" in the app and type this key, or open it directly on the phone you\'ll use.',
  copyKey: 'Copy key',
  openInAuthenticator: 'Open in authenticator app',
  setupStep2: '2. Enter the 6-digit code it shows',
  checking: 'Checking…',
  turnOn: 'Turn on',
  disableHelp: 'Confirm with your password and a current authenticator code (or a recovery code).',
  authenticatorOrRecoveryCode: 'Authenticator or recovery code',
  turningOff: 'Turning off…',
  turnOff: 'Turn off',
  onSinceCodesOne: 'On since {date}. {count} recovery code left.',
  onSinceCodesOther: 'On since {date}. {count} recovery codes left.',
  codesLeftOne: '{count} recovery code left.',
  codesLeftOther: '{count} recovery codes left.',
  starting: 'Starting…',
  enable: 'Enable',
}
